import { NAV_ROUTES } from '../../config/routes';

export function renderTerminalNav(): string {
    const navItems = NAV_ROUTES.map(route => (
        `<button class="terminal-nav__link" type="button" data-path="${route.path}">${route.label}</button>`
    )).join('');

    return `<nav class="terminal-nav">${navItems}</nav>`;
}
